<template>
  <el-card shadow="nerver" class="box-card" :body-style="{ padding: 0 }">
    <el-row class="box-card-contentContainer">
      <el-col :span="18" class="box-card-content">
        <el-row>
          <el-col :span="20" class="box-card-content-edit" v-if="optionModel.enableEdit">
            <el-form ref="dataModel" :model="dataModel" label-width="100px" label-position="right" :rules="rules">
              <el-form-item label="收费类型: ">
                <el-select v-model="dataModel.type" placeholder="请选择收费类型" :disabled="isStudentTopUpBalance" @change="onTypeChange">
                  <el-option v-for="(item, index) in otherCollectFeeTypes" :key="index" :label="item.description" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="电话号码: " prop="phone">
                <el-input placeholder="请输入电话号码" v-model.trim="dataModel.phone" class="input-width" :disabled="isStudentTopUpBalance" @change="onPhoneChange">
                </el-input>
              </el-form-item>
              <!--<div v-show="dataModel.type == this.GLOBAL.otherCollectFeeType.memberCard.value">
                <el-form-item label="购买年度: ">
                  <el-select
                    v-model="dataModel.feeYear"
                    placeholder="请选择购买年度"
                    @change="onYearChange"
                  >
                    <el-option
                      v-for="(item, index) in memberShipYears"
                      :key="index"
                      :label="item.description"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </div>-->

              <div v-if="dataModel.type == this.GLOBAL.otherCollectFeeType.videoPackage.value">
                <el-form-item label="课程: " prop="courseId">
                  <el-select v-model="dataModel.courseId" placeholder="请选择课程" @change="onCourseIdChange" v-loading="isLoading">
                    <el-option v-for="(item, index) in courseList" :key="index" :label="`${item.Name}${item.HasVideoPackage?' (已购买)':''}`" :value="item.Id"
                      :disabled="item.HasVideoPackage" />
                  </el-select>
                </el-form-item>
              </div>

              <div v-show="
                dataModel.type !=
                this.GLOBAL.otherCollectFeeType.bonusPointExchangeItem.value
              ">
                <el-form-item v-show="
                  dataModel.type ==
                  this.GLOBAL.otherCollectFeeType.academicPlanning.value
                " label="学业规划类型: ">
                  <el-select v-model="dataModel.subType" placeholder="请选择学业规划类型" @change="onSubTypeChange">
                    <el-option label="单次" :value="1"></el-option>
                    <el-option label="无限次" :value="2"></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="余额充值优惠: " prop="giftBalanceId"
                  v-if="dataModel.type == this.GLOBAL.otherCollectFeeType.topUpBalance.value && !isStudentTopUpBalance">
                  <el-select v-model="dataModel.giftBalanceId" placeholder="请选择余额充值优惠" @change="onGiftBalanceChange">
                    <el-option v-for="(item, index) in giftBalanceList" :key="index" :label="`${item.FullName}`" :value="item.Id"></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item :label="
                  dataModel.type ==
                    this.GLOBAL.otherCollectFeeType.topUpBalance.value
                    ? '充值金额: '
                    : '价格: '
                " prop="amount">
                  <el-input :placeholder="
                    dataModel.type ==
                      this.GLOBAL.otherCollectFeeType.topUpBalance.value
                      ? '请输入充值金额'
                      : '请输入价格'" v-model="dataModel.amount" class="input-width" :disabled="
                  amountInputDisable ||
                  (dataModel.type ==
                    this.GLOBAL.otherCollectFeeType.topUpBalance.value &&
                    dataModel.giftBalanceId > 0) " @change="onAmountChange"></el-input>
                </el-form-item>
                <el-form-item label="数量: " prop="quantity" v-show="!quantityInputDisable">
                  <el-input placeholder="请输入数量" v-model="dataModel.quantity" class="input-width" :disabled="quantityInputDisable"
                    @change="onQuantityChange"></el-input>
                </el-form-item>
              </div>
              <div v-show="
                dataModel.type ==
                this.GLOBAL.otherCollectFeeType.bonusPointExchangeItem.value
              ">
                <el-form-item label="兑换物品: " prop="bpeItemId">
                  <el-select v-model="dataModel.bpeItemId" placeholder="请选择兑换物品" @change="onBonusPointExchangeItemChange">
                    <el-option v-for="(item, index) in bonusPointExchangeItems" :key="index" :label="`${item.ItemName} (${item.BonusPoint})`"
                      :value="item.Id"></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-form>
          </el-col>
          <el-col :span="20" class="box-card-content-view" v-else>
            <el-row>
              <el-col :span="6">
                <span>收费类型: </span>
              </el-col>
              <el-col :span="18">
                <span>{{ ocfTypeDescription }}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <span>电话号码: </span>
              </el-col>
              <el-col :span="18">
                <span>{{ dataModel.phone }}</span>
              </el-col>
            </el-row>
            <div v-if="
              dataModel.type ==
              this.GLOBAL.otherCollectFeeType.memberCard.value
            ">
              <el-row>
                <el-col :span="6">
                  <span>购买年度: </span>
                </el-col>
                <el-col :span="18">
                  <span>{{ membershipYearDescription }}</span>
                </el-col>
              </el-row>
            </div>
            <div v-if="
              dataModel.type !=
              this.GLOBAL.otherCollectFeeType.bonusPointExchangeItem.value
            ">
              <el-row v-if="
                dataModel.type ==
                this.GLOBAL.otherCollectFeeType.academicPlanning.value
              ">
                <el-col :span="6">
                  <span>学业规划类型: </span>
                </el-col>
                <el-col :span="18">
                  <span>{{ ocfSubTypeDescription }}</span>
                </el-col>
              </el-row>

              <div v-if="dataModel.type == this.GLOBAL.otherCollectFeeType.topUpBalance.value">
                <el-row>
                  <el-col :span="10">
                    <span>余额充值优惠：</span>
                  </el-col>
                  <el-col :span="14">
                    <span>{{ getGiftBalanceItemText() }}</span>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="10">
                    <span>充值金额：</span>
                  </el-col>
                  <el-col :span="14">
                    <span>{{ dataModel.amount | toCurrency }}</span>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="10">
                    <span>赠送金额：</span>
                  </el-col>
                  <el-col :span="14">
                    <span v-if="dataModel.giftAmount != null">{{ dataModel.giftAmount | toCurrency }}</span>
                    <span v-else>{{ 0 | toCurrency }}</span>
                  </el-col>
                </el-row>
              </div>

              <el-row v-if="dataModel.type == this.GLOBAL.otherCollectFeeType.videoPackage.value">
                <el-col :span="6">
                  <span>课程: </span>
                </el-col>
                <el-col :span="18">
                  <span>{{ courseName }}</span>
                </el-col>
              </el-row>

              <el-row v-if="dataModel.type != this.GLOBAL.otherCollectFeeType.topUpBalance.value">
                <el-col :span="6">
                  <span>价格: </span>
                </el-col>
                <el-col :span="18">
                  <span>{{ dataModel.amount | toCurrency }}</span>
                </el-col>
              </el-row>

              <el-row v-if="!quantityInputDisable">
                <el-col :span="6">
                  <span>数量: </span>
                </el-col>
                <el-col :span="18">
                  <span>{{ dataModel.quantity }}</span>
                </el-col>
              </el-row>
            </div>
            <div v-else>
              <el-row>
                <el-col :span="6">
                  <span>兑换物品: </span>
                </el-col>
                <el-col :span="18">
                  <span>{{ bpeItemName }}</span>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="6" class="box-card-subtotal">
        <div class="subtotal-contentContainer">
          <div class="subtotal-content">
            <el-row>
              <el-col>
                <span>小计</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <span>{{ dataModel.totalPrice | toCurrency }}</span>
                <span v-if="
                  dataModel.type ==
                  this.GLOBAL.otherCollectFeeType.bonusPointExchangeItem.value
                ">({{ dataModel.bonusPointCost }})</span>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
  </el-card>
</template>

<style lang="scss" scoped>
.box-card {
  background-color: #f5f7fa;

  .box-card-contentContainer {
    min-height: 200px;

    .box-card-content {
      padding: 20px;
    }

    .box-card-subtotal {
      padding: 20px;
      background-color: #e1edf7;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;

      .subtotal-contentContainer {
        width: 100%;
        height: 100%;
        text-align: center;
        display: table;

        .subtotal-content {
          display: table-cell;
          vertical-align: middle;

          span {
            display: block;
          }
        }
      }
    }
  }
}
</style>

<script>
import { typeOf, arrayEquals } from "../../../config/mUtils";
import { getStudentMemberInfo } from "../../../service/student.service";
import { getCurrentTerm } from "../../../service/speedupCourse.service";
import { getStudentCurrentTermCourses } from "@/service/student.service";

export default {
  props: {
    options: {
      enableEdit: Boolean,
    },
    data: {
      priceSettings: Object,
      otherCollectFeeTypes: Array,
      memberShipYears: Array,
      bonusPointMechanisms: {
        bonusPointToMoneyRate: Number,
      },
      bonusPointExchangeItems: Array,
      giftBalanceList: Array,
      ocfType: Number,
      year: Number,
      subType: Number,
      studentId: Number,
      phone: String,
      comment: String,
      amount: Number,
      giftAmount: Number,
      quantity: Number,
      totalPrice: Number,
      bpeItemId: Number,
      giftBalanceId: Number,
      bonusPointCost: Number,
      courseId: Number,
    },
  },
  data() {
    let self = this;

    let validatePhone = (rule, value, callback) => {
      if (this.isLoading) {
        return;
      }
      if (!value) {
        callback(new Error("电话号码不能为空"));
        return;
      }

      let pattern = /^\d{10,11}$/g;
      let isValid = pattern.test(value);
      if (!isValid) {
        callback(new Error("请输入正确的电话号码"));
        return;
      }

      let message = "";
      if (!self.dataModel.studentId) {
        message = "未找到该电话号码的学生";
      } else {
        if (
          self.dataModel.type ==
            this.GLOBAL.otherCollectFeeType.memberCard.value &&
          self.studentModel.IsMember
        )
          message = "该电话号码的学生已是会员";
        if (
          self.dataModel.type ==
            this.GLOBAL.otherCollectFeeType.renewMemberCard.value &&
          !self.studentModel.IsMember
        )
          message = "该电话号码的学生还不是会员";
        if (
          self.dataModel.type ==
            this.GLOBAL.otherCollectFeeType.extendMemberCard.value &&
          !self.studentModel.IsMember
        )
          message = "该电话号码的学生还不是会员";
      }
      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }

      // self.studentModel = null;
      // self.dataModel.studentId = 0;

      // getStudentMemberInfo(null, value).then(async (result) => {
      //   if (!!result && result.success) {
      //     self.studentModel = result.data;
      //     self.dataModel.studentId = result.data.StudentId;
      //     if (
      //       self.dataModel.type ==
      //       this.GLOBAL.otherCollectFeeType.memberCard.value &&
      //       self.studentModel.IsMember
      //     )
      //       message = "该电话号码的学生已是会员";
      //     if (
      //       self.dataModel.type ==
      //       this.GLOBAL.otherCollectFeeType.renewMemberCard.value &&
      //       !self.studentModel.IsMember
      //     )
      //       message = "该电话号码的学生还不是会员";
      //     if (
      //       self.dataModel.type ==
      //       this.GLOBAL.otherCollectFeeType.extendMemberCard.value &&
      //       !self.studentModel.IsMember
      //     )
      //       message = "该电话号码的学生还不是会员";

      //     if (self.dataModel.type == this.GLOBAL.otherCollectFeeType.videoPackage.value) {
      //       this.courseList = await this.loadStudentCurrentTermCoursesFromServer();
      //     }
      //   } else {
      //     message = !!result ? result.message : "未找到该电话号码的学生";
      //   }

      //   if (!!message) {
      //     callback(new Error(message));
      //   } else {
      //     callback();
      //   }
      //});
    };

    let validateQuantity = (rule, value, callback) => {
      let message = "";

      if (!!value) {
        let pattern = /^\d+(\.\d+)?$/g;
        let isValid = pattern.test(value);
        if (!isValid) message = "请输入正确的数量";
        if (!message && value == 0) message = "数量不能为0";
      } else if (value == 0) {
        message = "数量不能为0";
      }

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }
    };

    let validateAmount = (rule, value, callback) => {
      let message = "";

      if (!!value) {
        let pattern = /^\d+(\.\d+)?$/g;
        let isValid = pattern.test(value);
        if (!isValid) message = "请输入正确的价格";
        if (!message && value == 0) message = "价格不能为0";
      } else if (value == 0) {
        message = "价格不能为0";
      }

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }
    };

    let validateBPEItemId = (rule, value, callback) => {
      let message = "";

      if (
        self.dataModel.type ==
        self.GLOBAL.otherCollectFeeType.bonusPointExchangeItem.value
      ) {
        if (!value) message = "请选择积分兑换物品";

        let bonusPoint = !!self.studentModel ? self.studentModel.BonusPoint : 0;
        let bpeItem = self.__findBonusPointExchangeItem(value);
        let bonusPointCost = !!bpeItem ? bpeItem.BonusPoint : 0;
        if (!message && bonusPoint < bonusPointCost)
          message = "积分不足以兑换该物品";
      }

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }
    };

    return {
      quantityInputDisable: true,
      amountInputDisable: true,
      priceSettings: {
        normalVideoPrice: 0,
        supplementVideoPrice: 0,
        membershipCardPrice: 0,
        paymentCommissionRate: 0,
        renewMembershipCardPrice: 0,
        academicPlanningOnce: 0,
        academicPlanningUnlimited: 0,
        afterDiscountMembershipCardPrice: 0,
        extendMembershipCardPrice: 0,
        airportPickUpPrice: 0,
        videoPackagePrice: 0,
        autoEnrollCoursePrice: 0
      },
      otherCollectFeeTypes: [],
      memberShipYears: [],
      bonusPointMechanisms: {
        bonusPointToMoneyRate: 0,
      },
      bonusPointExchangeItems: [],
      giftBalanceList: [],
      studentModel: null,
      optionModel: {
        enableEdit: true,
      },
      dataModel: {
        type: 0,
        year: 0,
        subType: null,
        membershipYear: 0,
        studentId: 0,
        phone: null,
        comment: null,
        amount: 0,
        quantity: 0,
        totalPrice: 0,
        bpeItemId: null,
        bonusPointCost: 0,
        giftBalanceId: null,
        giftAmount: null,
        courseId: null,
      },
      rules: {
        phone: {
          validator: validatePhone,
          trigger: "blur",
        },
        quantity: [
          {
            required: true,
            message: "数量不能为空",
            trigger: "blur",
          },
          {
            validator: validateQuantity,
            trigger: "blur",
          },
        ],
        amount: [
          {
            required: true,
            message: "价格不能为空",
            trigger: "blur",
          },
          {
            validator: validateAmount,
            trigger: "blur",
          },
        ],
        bpeItemId: {
          validator: validateBPEItemId,
          trigger: "blur",
        },
        courseId: [
          {
            required: true,
            message: "课程不能为空",
            trigger: "blur",
          },
        ],
      },
      courseList: [],
      isCourseListLoaded: false,
      isLoading: false,
    };
  },
  computed: {
    isStudentTopUpBalance() {
      if (!this.USERMANAGER.isStudent) return false;
      return this.$route.name === "addCollectFeesTopUpBalance";
    },
    ocfTypeDescription: function () {
      let ocfType = this.__findOtherCollectFeeTypeByValue(this.dataModel.type);
      return !!ocfType ? ocfType.description : null;
    },
    membershipYearDescription: function () {
      let feeYear = this.__findMemberShipYearByValue(this.dataModel.feeYear);
      return !!feeYear ? feeYear.description : null;
    },
    ocfSubTypeDescription: function () {
      if (!this.dataModel.subType) return null;

      let result = null;
      switch (this.dataModel.subType) {
        case 1:
          result = "单次";
          break;
        case 2:
          result = "无限次";
          break;
      }

      return result;
    },
    bpeItemName: function () {
      let bpeItem = this.__findBonusPointExchangeItem(this.dataModel.bpeItemId);
      return !!bpeItem ? bpeItem.ItemName : null;
    },
    courseName() {
      var course = this.courseList.find(
        (item) => item.Id === this.dataModel.courseId
      );
      return !!course ? course.Name : String.empty;
    },
  },
  created() {
    this.loadOptionsFromProps();
  },
  mounted() {
    this.loadDataFromProps();
  },
  methods: {
    async loadStudentMemberInfo(loadById) {
      this.isLoading = true;
      this.studentModel = null;

      if (loadById && this.dataModel.studentId) {
        let result = await getStudentMemberInfo(this.dataModel.studentId);
        if (!!result && result.success) {
          this.studentModel = result.data;
        }
      } else {
        this.dataModel.studentId = 0;
        if (!this.dataModel.phone) {
          this.dataModel.courseId = null;
          this.isLoading = false;
          return;
        }
        let result = await getStudentMemberInfo(null, this.dataModel.phone);
        if (!!result && result.success) {
          this.studentModel = result.data;
          this.dataModel.studentId = result.data.StudentId;
        }
      }

      if (this.dataModel.studentId) {
        this.isCourseListLoaded = false;
        await this.loadCourseList();
      }
      this.isLoading = false;
    },
    async loadCourseList() {
      if (
        this.dataModel.studentId &&
        this.dataModel.type ==
          this.GLOBAL.otherCollectFeeType.videoPackage.value &&
        !this.isCourseListLoaded
      ) {
        this.isLoading = true;
        this.courseList = await this.loadStudentCurrentTermCoursesFromServer();
        this.isCourseListLoaded = true;
        this.isLoading = false;
      }
    },
    async loadStudentCurrentTermCoursesFromServer() {
      if (!this.dataModel.studentId) return [];
      let result = await getStudentCurrentTermCourses(
        this.GLOBAL.enumNormalCourseCategory.OfflineCourse,
        this.dataModel.studentId,
        this.optionModel.enableEdit
      );
      return !!result && result.success ? result.data : [];
    },

    loadOptionsFromProps(options = this.options) {
      if (!!options) {
        this.optionModel.enableEdit = options.enableEdit;
      } else {
        this.optionModel.enableEdit = true;
      }
    },
    async loadDataFromProps(data = this.data) {
     
      let isLoadStudent = false;
      if (!!data) {
        if (!!data.priceSettings) {
          this.priceSettings.normalVideoPrice =
            data.priceSettings.normalVideoPrice;
          this.priceSettings.supplementVideoPrice =
            data.priceSettings.supplementVideoPrice;
          this.priceSettings.membershipCardPrice =
            data.priceSettings.membershipCardPrice;
          this.priceSettings.paymentCommissionRate =
            data.priceSettings.paymentCommissionRate;
          this.priceSettings.renewMembershipCardPrice =
            data.priceSettings.renewMembershipCardPrice;
          this.priceSettings.academicPlanningOnce =
            data.priceSettings.academicPlanningOnce;
          this.priceSettings.academicPlanningUnlimited =
            data.priceSettings.academicPlanningUnlimited;
          this.priceSettings.afterDiscountMembershipCardPrice =
            data.priceSettings.afterDiscountMembershipCardPrice;
          this.priceSettings.extendMembershipCardPrice =
            data.priceSettings.extendMembershipCardPrice;
          this.priceSettings.airportPickUpPrice = data.priceSettings.airportPickUpPrice;
          this.priceSettings.videoPackagePrice = data.priceSettings.videoPackagePrice;
          this.priceSettings.autoEnrollCoursePrice = data.priceSettings.autoEnrollCoursePrice;
        } else {
          this.priceSettings.normalVideoPrice = 0;
          this.priceSettings.supplementVideoPrice = 0;
          this.priceSettings.membershipCardPrice = 0;
          this.priceSettings.paymentCommissionRate = 0;
          this.priceSettings.renewMembershipCardPrice = 0;
          this.priceSettings.academicPlanningOnce = 0;
          this.priceSettings.academicPlanningUnlimited = 0;
          this.priceSettings.afterDiscountMembershipCardPrice = 0;
          this.priceSettings.extendMembershipCardPrice = 0;
          this.priceSettings.airportPickUpPrice = 0;
          this.priceSettings.videoPackagePrice = 0;
          this.priceSettings.autoEnrollCoursePrice = 0;
        }

        if (!!data.otherCollectFeeTypes)
          this.otherCollectFeeTypes = data.otherCollectFeeTypes;
        else this.otherCollectFeeTypes = [];

        if (!!data.memberShipYears) {
          this.memberShipYears = data.memberShipYears;
        } else {
          this.memberShipYears = [];
        }

        if (!!data.bonusPointMechanisms)
          this.bonusPointMechanisms.bonusPointToMoneyRate =
            data.bonusPointMechanisms.bonusPointToMoneyRate;
        else this.bonusPointMechanisms.bonusPointToMoneyRate = 0;

        if (!!data.bonusPointExchangeItems)
          this.bonusPointExchangeItems = data.bonusPointExchangeItems;
        else this.bonusPointExchangeItems = [];

        if (!!data.giftBalanceList) {
          this.giftBalanceList = data.giftBalanceList;
        } else {
          this.giftBalanceList = [];
        }

        this.dataModel.type = data.ocfType;
        this.dataModel.feeYear = !!data.feeYear ? data.feeYear : 0;
        this.dataModel.subType = data.subType;
        this.dataModel.studentId = data.studentId;
        this.dataModel.phone = data.phone;
        this.dataModel.comment = data.comment;

        this.dataModel.amount = data.amount;

        this.dataModel.quantity = data.quantity;
        this.dataModel.totalPrice = data.totalPrice;
        this.dataModel.bpeItemId = data.bpeItemId;
        this.dataModel.giftBalanceId = data.giftBalanceId;
        this.dataModel.giftAmount = data.giftAmount;
        this.dataModel.bonusPointCost = data.bonusPointCost;
        this.dataModel.courseId = data.courseId;

        isLoadStudent = true;
        this.resetSubType();
        if (!data.amount){
          this.calculateAmount();
          this.resetGiftBalance();
        }
      } else {
        this.initPriceSettings();
        this.initDataModel();
        this.resetSubType();
        this.calculateAmount();
        this.resetGiftBalance();
      }

      this.resetQuantity(this.dataModel.type, this.dataModel.quantity);
      if (!this.dataModel.giftBalanceId && this.dataModel.giftBalanceId !== 0) {
        this.calculateAmount();
        this.resetGiftBalance();
      }

      if (isLoadStudent) {
        await this.loadStudentMemberInfo(!!this.dataModel.studentId);
        if (!this.studentModel || !this.studentModel.StudentId) {
          this.courseList = [];
        }
      }

      if (!this.optionModel.enableEdit) return;

      if (
        this.dataModel.type !=
        this.GLOBAL.otherCollectFeeType.bonusPointExchangeItem.value
      )
        this.checkAllInputs();
      else this.checkInputsForBPEItem();
    },
    checkAllInputs(onlyCheck = false) {
      this.$nextTick(()=>{
        this.checkAllInputsForCard(onlyCheck);
      });
    },
    async checkAllInputsForCard(onlyCheck = false) {
      let isValid = true;

      if (!onlyCheck) {
        this.triggerValidateInit();
      }

      let $ref = this.$refs["dataModel"];
      if (!!$ref) {
        let isCompleted = false;
        $ref.validate((valid) => {
          if (!valid) {
            isValid = false;
          }
          isCompleted = true;
        });

        while (!isCompleted) {
          await this.__sleep();
        }
      }

      if (!onlyCheck) {
        this.triggerValidateDone(isValid);
      }

      return isValid;
    },
    async checkInputsForBPEItem(onlyCheck = false) {
      let isValid = true;

      if (!onlyCheck) {
        this.triggerValidateInit();
      }

      let $ref = this.$refs["dataModel"];
      if (!!$ref) {
        let valid1 = true;
        let isCompleted = false;
        $ref.validateField("phone", (error) => {
          if (!!error) {
            valid1 = false;
          }
          isCompleted = true;
        });

        while (!isCompleted) {
          await this.__sleep();
        }

        let valid2 = true;
        $ref.validateField("bpeItemId", (error) => {
          if (!!error) {
            valid2 = false;
          }
        });

        isValid = valid1 && valid2;
      }

      if (!onlyCheck) {
        this.triggerValidateDone(isValid);
      }

      return isValid;
    },
    initPriceSettings() {
      this.priceSettings.normalVideoPrice = 0;
      this.priceSettings.supplementVideoPrice = 0;
      this.priceSettings.membershipCardPrice = 0;
      this.priceSettings.paymentCommissionRate = 0;
      this.priceSettings.renewMembershipCardPrice = 0;
      this.priceSettings.academicPlanningOnce = 0;
      this.priceSettings.academicPlanningUnlimited = 0;
      this.priceSettings.afterDiscountMembershipCardPrice = 0;
      this.priceSettings.extendMembershipCardPrice = 0;
      this.priceSettings.airportPickUpPrice = 0;
      this.priceSettings.videoPackagePrice = 0;
      this.priceSettings.autoEnrollCoursePrice = 0;
    },
    initDataModel(
      ocfType = this.otherCollectFeeTypes.length > 0
        ? this.otherCollectFeeTypes[0].value
        : 0,
      membershipYear = this.memberShipYears.length > 0
        ? this.memberShipYears[0].value
        : this.getCurrentYear()
    ) {
      this.dataModel.type = ocfType;
      this.dataModel.membershipYear = membershipYear;
      this.dataModel.subType = null;
      this.dataModel.studentId = 0;
      this.dataModel.phone = null;
      this.dataModel.comment = null;
      this.dataModel.amount = 0;
      this.dataModel.quantity = 1;
      this.dataModel.totalPrice = 0;
      this.dataModel.bpeItemId = null;
      this.dataModel.giftBalanceId = null;
      this.dataModel.giftAmount = null;
      this.dataModel.bonusPointCost = 0;
      this.dataModel.courseId = null;
      this.courseList = [];
    },
    calculateAmount(
      typeValue = this.dataModel.type,
      subTypeValue = this.dataModel.subType
    ) {
      switch (typeValue) {
        case this.GLOBAL.otherCollectFeeType.memberCard.value: {
          //if(this.dataModel.feeYear == 0)
          //  this.dataModel.amount = this.priceSettings.afterDiscountMembershipCardPrice;
          //else
          this.dataModel.amount = this.priceSettings.membershipCardPrice;
          break;
        }
        case this.GLOBAL.otherCollectFeeType.renewMemberCard.value: {
          this.dataModel.amount = this.priceSettings.renewMembershipCardPrice;
          break;
        }
        case this.GLOBAL.otherCollectFeeType.extendMemberCard.value: {
          this.dataModel.amount = this.priceSettings.extendMembershipCardPrice;
          break;
        }
        case this.GLOBAL.otherCollectFeeType.watchVideos.value: {
          this.dataModel.amount = this.priceSettings.normalVideoPrice;
          break;
        }
        case this.GLOBAL.otherCollectFeeType.bonusPointExchangeItem.value: {
          this.dataModel.amount =
            this.dataModel.bonusPointCost *
            this.bonusPointMechanisms.bonusPointToMoneyRate;
          break;
        }
        case this.GLOBAL.otherCollectFeeType.academicPlanning.value: {
          let newAmount = 0;
          if (!!subTypeValue) {
            switch (subTypeValue) {
              case 1:
                newAmount = this.priceSettings.academicPlanningOnce;
                break;
              case 2:
                newAmount = this.priceSettings.academicPlanningUnlimited;
                break;
            }
          }
          this.dataModel.amount = newAmount;
          break;
        }
        case this.GLOBAL.otherCollectFeeType.airportPickUp.value: {
          this.dataModel.amount = this.priceSettings.airportPickUpPrice;
          break;
        }
        case this.GLOBAL.otherCollectFeeType.videoPackage.value: {
          this.dataModel.amount = this.priceSettings.videoPackagePrice;
          break;
        }
        case this.GLOBAL.otherCollectFeeType.topUpBalance.value: {
          let item = this.__findGiftBalanceItem();
          if (!!item) {
            this.dataModel.amount = item.IncreasedAmount;
            this.dataModel.giftAmount = item.GiftAmount;
          } else {
            this.dataModel.amount = 0;
            this.dataModel.giftAmount = 0;
          }
          break;
        }
        case this.GLOBAL.otherCollectFeeType.autoEnrollCourse.value:{
          this.dataModel.amount = this.priceSettings.autoEnrollCoursePrice;
          break;
        }
      }
      this.calculateTotalAmount();
    },
    resetSubType(typeValue = this.dataModel.type) {
      if (typeValue == this.GLOBAL.otherCollectFeeType.academicPlanning.value) {
        this.dataModel.subType = 1;
      } else {
        this.dataModel.subType = null;
      }
    },
    resetQuantity(typeValue = this.dataModel.type, defaultQuantity = 1) {
      let quantityInputDisable = true;
      let amountInputDisable = true;
      switch (typeValue) {
        case this.GLOBAL.otherCollectFeeType.watchVideos.value:
          quantityInputDisable = false;
          break;
        case this.GLOBAL.otherCollectFeeType.topUpBalance.value:
          amountInputDisable = false;
          break;
      }

      this.quantityInputDisable = quantityInputDisable;
      this.amountInputDisable = amountInputDisable;
      this.dataModel.quantity = defaultQuantity;
    },
    resetBPEItemId(typeValue = this.dataModel.type) {
      this.dataModel.bpeItemId = null;
      this.dataModel.bonusPointCost = 0;
    },
    resetGiftBalance() {
      if (
        this.dataModel.type ==
        this.GLOBAL.otherCollectFeeType.topUpBalance.value
      ) {
        this.dataModel.giftBalanceId = 0;
      } else {
        this.dataModel.giftBalanceId = null;
      }
      this.dataModel.giftAmount = null;
    },
    calculateTotalAmount(
      amount = this.dataModel.amount,
      quantity = this.dataModel.quantity
    ) {
      let amountNumber = 0;
      let amountType = typeOf(amount);
      switch (amountType) {
        case "number":
          amountNumber = amount;
          break;
        case "string":
          let parseResult = parseFloat(amount);
          if (!isNaN(parseResult)) amountNumber = parseResult;
          break;
      }

      let quantityNumber = 0;
      let quantityType = typeOf(quantity);
      switch (quantityType) {
        case "number":
          quantityNumber = quantity;
          break;
        case "string":
          let parseResult = parseFloat(quantity);
          if (!isNaN(parseResult)) quantityNumber = parseResult;
          break;
      }

      this.dataModel.totalPrice = amountNumber * quantityNumber;
    },
    onTypeChange(newVal) {
      this.resetSubType(newVal);
      this.calculateAmount(newVal);
      this.resetQuantity(newVal);
      this.resetBPEItemId(newVal);
      this.resetGiftBalance();
      this.loadCourseList();
      this.checkAllInputs();
    },
    onSubTypeChange(newVal) {
      this.calculateAmount(this.dataModel.type, newVal);
      this.checkAllInputs();
    },
    async onPhoneChange(newVal) {
      if (!!this.dataModel.phone) {
        this.dataModel.phone = this.dataModel.phone.trim();
        this.dataModel.courseId = null;
      }
      await this.loadStudentMemberInfo();

      if (
        this.dataModel.type !=
        this.GLOBAL.otherCollectFeeType.bonusPointExchangeItem.value
      )
        this.checkAllInputs();
      else this.checkInputsForBPEItem();
    },
    onQuantityChange(newVal) {
      this.checkAllInputs();
    },
    onAmountChange(newVal) {
      this.checkAllInputs();
    },
    onBonusPointExchangeItemChange(newVal) {
      let item = this.__findBonusPointExchangeItem(newVal);
      if (!item) return;

      this.dataModel.bonusPointCost = item.BonusPoint;
      this.calculateAmount();
      this.checkInputsForBPEItem();
    },
    onYearChange(newVal) {
      this.calculateAmount();
      this.checkAllInputs();
    },
    onGiftBalanceChange() {
      this.calculateAmount();
      this.checkAllInputs();
    },
    onCourseIdChange() {
      this.checkAllInputs();
    },
    triggerValidateInit() {
      this.$emit("validate-init");
    },
    triggerValidateDone(isValid) {
      this.calculateTotalAmount();

      let dataOut = {
        isValid: isValid,
        data: this.dataModel,
      };

      this.$emit("validate-done", dataOut);
    },
    getCurrentYear() {
      let currentYear = new Date.getFullYear();
      return currentYear;
    },
    __sleep(time = 500) {
      return new Promise((resolve) => setTimeout(resolve, time));
    },
    __findOtherCollectFeeTypeByValue(typeValue) {
      let result = null;
      for (let i = 0; i < this.otherCollectFeeTypes.length; i++) {
        let field = this.otherCollectFeeTypes[i];
        if (field.value == typeValue) {
          result = field;
          break;
        }
      }
      return result;
    },
    __findMemberShipYearByValue(yearValue) {
      let result = null;
      for (let i = 0; i < this.memberShipYears.length; i++) {
        let field = this.memberShipYears[i];
        if (field.value == yearValue) {
          result = field;
          break;
        }
      }
      return result;
    },
    __findBonusPointExchangeItem(id) {
      let result = null;
      for (let i = 0; i < this.bonusPointExchangeItems.length; i++) {
        let item = this.bonusPointExchangeItems[i];
        if (item.Id == id) {
          result = item;
          break;
        }
      }
      return result;
    },
    __findGiftBalanceItem() {
      return this.giftBalanceList.find(
        (i) => i.Id == this.dataModel.giftBalanceId
      );
    },
    getGiftBalanceItemText() {
      let item = this.__findGiftBalanceItem();
      if (!!item) {
        return item.FullName;
      }
      return "";
    },
  },
  watch: {
    options: function (newVal) {
      this.loadOptionsFromProps(newVal);
    },
    data: function (newVal) {
      this.loadDataFromProps(newVal);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/addCollectFees/otherCollectFee/ocfWorkflowCard.vue